import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICompleteDriverTripDto } from 'src/core/interfaces/IComplete-driver-trip';
import { ILoadingOrder } from 'src/core/interfaces/loading-order';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoadingOrderService {
  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<any>(`${this._baseUrl}/loadingorder`);
  }

  getById(id: number) {
    return this.http.get<any>(`${this._baseUrl}/loadingorder/${id}`);
  }

  add(loadingOrder: any) {
    const formData = new FormData();
    Object.keys(loadingOrder).forEach((key) => {
      formData.append(key, (loadingOrder as any)[key]);
    });
    return this.http.post<any>(`${this._baseUrl}/loadingorder/Add`, formData);
  }

  update(id: number, loadingOrder: ILoadingOrder) {
    const formData = new FormData();
    Object.keys(loadingOrder).forEach((key) => {
      formData.append(key, (loadingOrder as any)[key]);
    });
    return this.http.patch<any>(
      `${this._baseUrl}/loadingorder/${id}`,
      formData
    );
  }

  delete(id: number) {
    return this.http.delete<any>(`${this._baseUrl}/loadingorder/${id}`);
  }

  deleteRange(ids: number[]) {
    return this.http.delete<any>(`${this._baseUrl}/loadingorder/Delete/Range`, {
      body: ids
    });
  }

  getAllPaginated(
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null,
  ) {
    return this.http.get<any>(
      `${this._baseUrl}/loadingorder/paginated?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`
    );
  }

  downloadReport(status: number, fromDate: string, toDate: string) {
    const body = { status, fromDate, toDate };
    return this.http.post(`${this._baseUrl}/LoadingOrder/download_report`, body, { responseType: 'blob' });
  }

  approve(id: number) {
    return this.http.post<any>(`${this._baseUrl}/LoadingOrder/approve/${id}`, {});
  }

  getCustomerOrders(
    customerId: number,
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null,
  ) {

    const url = `${this._baseUrl}/loadingorder/customerOrders/paginated`;
    let query = `?customer_id=${customerId != null ? customerId:-1}&pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`;

    if (criteria) {
      query += `&criteria=${criteria}`;
    }

    return this.http.get<any>(`${url}${query}`); 

    // return this.http.get<any>(
    //   `${this._baseUrl}/loadingorder/customerOrders/paginated?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}/${custoemr_id}`
    // );
  }

  getDriverTrips(
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null
  ) {
    return this.http.get<any>(
      `${this._baseUrl}/loadingorder/driverTrips?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`
    );
  }



  completeDriverTrip(id,CompleteDriverTripDto : ICompleteDriverTripDto) {
    const formData = new FormData();
    formData.append('DeliveryAuthAttachmentFileContent', CompleteDriverTripDto.deliveryAuthAttachmentFileContent);
    formData.append('DeliveryAuthAttachmentFileName', CompleteDriverTripDto.deliveryAuthAttachmentFileName);
    formData.append('actualDeliveredQuantity', CompleteDriverTripDto.actualDeliveredQuantity.toString());
    formData.append('deliveryNumber', CompleteDriverTripDto.deliveryNumber.toString());


    return this.http.post<any>(`${this._baseUrl}/LoadingOrder/driverTrip/complete/${id}`, formData);
  }


  getLoadingOrderDataFromSalesOrderLine(id: number){
    return this.http.get<any>(`${this._baseUrl}/loadingorder/getLoadingOrderDataFromSalesOrderLine/${id}`);
  }

  downloadFile(filePath: string): void {
    const url = `${this._baseUrl}/loadingorder/downloadFile?filePath=${encodeURIComponent(filePath)}`;
    this.http
      .get(url, { responseType: 'blob' }) // Ensure response is treated as a Blob
      .subscribe({
        next: (blob) => {
          const fileName = filePath.split('/').pop() || 'file';
          const link = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          link.href = objectUrl;
          link.download = fileName;
          link.click();
          URL.revokeObjectURL(objectUrl);
        },
        error: (err) => console.error('File download failed:', err),
      });
  }

}
